import { Col, Divider, Row } from "antd";
import { InfoDeparturesClients } from "./info";

export default function DeparturesHistory(){

    return(
        <Row>
            <Col lg={24} xs={24}>
            <div style={{ fontSize: '1.1em', fontWeight: 'bold' }}>Estado de despachos</div>
            <Divider />
            <InfoDeparturesClients />
            </Col>
        </Row>
    );
}